import { useState, useEffect, useContext } from "react";
import { Switch, Tooltip, Typography, Space } from "antd";
import { AuthContext } from "../../context/AuthContext";
import { useTranslation } from "react-i18next";
import { useGlobalToast } from "../../context/ToastProvider";
import { getFleetDetails, updateFleetDetails } from "../../services/fleetDetailsFirestore";

export default function CO2Switch({ fleetId: fleetIdProp }) {
  const { getFleetID } = useContext(AuthContext);
  const fleetId = fleetIdProp || getFleetID();
  const [isEnabled, setIsEnabled] = useState(false);
  const [loading, setLoading] = useState(false);
  const toast = useGlobalToast();
  const { t } = useTranslation();

  useEffect(() => {
    const fetchUseCO2 = async () => {
      try {
        const details = await getFleetDetails(fleetId);
        setIsEnabled(details?.useCO2Calculator ?? false);
      } catch (error) {
        console.error("Error al obtener estado de useCO2Calculator:", error);
      }
    };

    if (fleetId) {
      fetchUseCO2();
    }
  }, [fleetId]);

  const handleToggle = async () => {
    const newValue = !isEnabled;
    setLoading(true);
    try {
      await updateFleetDetails(fleetId, { useCO2Calculator: newValue });

      setIsEnabled(newValue);

      toast({
        title: newValue
          ? t("setup.co2Enabled") || "Calculadora CO2 activada"
          : t("setup.co2Disabled") || "Calculadora CO2 desactivada",
        status: "success",
      });
    } catch (error) {
      console.error("Error al actualizar useCO2Calculator:", error);
      toast({ error,
        title: t("setup.co2UpdateError"),
        status: "warning",
      });
    } finally {
      setLoading(false);
    }
  };

  // Funcionalidad aún no disponible, se fuerza como desactivado
  const isDisabled = true;
  return (
    <Space align="center" style={{ marginTop: 12 }}>
      <Typography.Text>{t("setup.useCO2Calculator") || "Usar calculadora CO2"}</Typography.Text>
      <Tooltip title={t("setup.co2Unavailable") || "Funcionalidad en desarrollo"}>
        <span>
          <Switch checked={isEnabled} onChange={() => {}} disabled={isDisabled} />
        </span>
      </Tooltip>
    </Space>
  );
}
